import { useState, useEffect } from 'react'
import type { SyncEvent, SyncStatus } from '../services/syncService'
import { isSupabaseConfigured } from '../lib/supabaseClient'

export interface SyncStatusState {
  configured: boolean
  statuses: Map<string, SyncStatus>
  isAnyPending: boolean
  hasError: boolean
}

export function useSyncStatus(): SyncStatusState {
  const [configured] = useState(isSupabaseConfigured)
  const [statuses, setStatuses] = useState<Map<string, SyncStatus>>(new Map())

  useEffect(() => {
    if (!configured) return

    function onSyncEvent(e: Event) {
      const { key, status } = (e as CustomEvent<SyncEvent>).detail
      setStatuses((prev) => {
        const next = new Map(prev)
        next.set(key, status)
        return next
      })
    }

    window.addEventListener('energymatch:sync', onSyncEvent)
    return () => window.removeEventListener('energymatch:sync', onSyncEvent)
  }, [configured])

  const values = Array.from(statuses.values())
  const isAnyPending = values.some((s) => s === 'syncing')
  const hasError = values.some((s) => s === 'error')

  return { configured, statuses, isAnyPending, hasError }
}
